// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterGuarantorCompanyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SaveGuarantorCompanyWebApiRequestDto } from '../..';

export const CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany_Path =
  '/api/web/renter/v1/guarantor/saveGuarantorCompany';

export const CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany = (
  postData: SaveGuarantorCompanyWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SaveGuarantorCompanyWebApiRequestDto, void>(
    {
      endpoint: CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
